// extracted by mini-css-extract-plugin
module.exports = {"unit":"var(--ring-unit)","actions":"QueueActions__actions--c1","plugins":"QueueActions__plugins--qG","clear":"QueueActions__clear--fl"};